import { c } from "react/compiler-runtime";
import { parseAll } from "@effektify/parser";
import useLogger from "./useLogger.js";
const useParseConfig = yamlData => {
  const $ = c(3);
  const logger = useLogger("useParseConfig");
  let t0;
  if ($[0] !== logger || $[1] !== yamlData) {
    bb0: {
      if (typeof yamlData !== "string") {
        t0 = yamlData;
        break bb0;
      }
      const parsedConfig = parseAll(yamlData);
      if (!parsedConfig || parsedConfig instanceof Error) {
        logger.error("Error parsing config:", parsedConfig);
        t0 = null;
        break bb0;
      }
      t0 = parsedConfig;
    }
    $[0] = logger;
    $[1] = yamlData;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export { useParseConfig as default };